/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    SimpleLoginFormData,
    LoginResponseData,
    MisLoginFormData,
    MisLoginResponseData,
    AUTH_API_URLS_PREFIX,
    MisAuthStatusResponseData,
    UiType,
} from './authClient.typings';
import apiClient from '../apiClient';
import { convertToFormData, toHash } from '../../../utils/utils';

async function simpleLogin(data: SimpleLoginFormData): Promise<LoginResponseData> {
    const password = await toHash(data.password);
    const { username, token, rememberMe } = data;

    return apiClient.post(
        '1.0.0' + AUTH_API_URLS_PREFIX + '/simple',
        convertToFormData({ username, password, rememberMe }),
        token
            ? {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                      Token: token,
                  },
              }
            : {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              },
    );
}

const misSendUserInfo = (data: MisLoginFormData, uiType: UiType): Promise<MisLoginResponseData & LoginResponseData> => {
    return apiClient.post('1.0.0' + AUTH_API_URLS_PREFIX + '/mis', convertToFormData({ ...data, uiType }), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const misAuthComplete = (taxNumber: string, uiType: UiType): Promise<LoginResponseData> => {
    return apiClient.post('1.0.0' + AUTH_API_URLS_PREFIX + '/mis/complete', convertToFormData({ taxNumber, uiType }), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const misCheckAuthenticate = (): Promise<MisAuthStatusResponseData> => {
    return apiClient.get('1.0.0' + AUTH_API_URLS_PREFIX + '/mis/statuses');
};

const logout = (): Promise<void> => {
    return apiClient.post(`1.0.0${AUTH_API_URLS_PREFIX}/logout`, null);
};

export const authClient = {
    simpleLogin,
    misSendUserInfo,
    misCheckAuthenticate,
    logout,
    misAuthComplete,
};
